<template>
  <div v-if="!loading && sites.length">
    <rule-card
      v-for="site in sites"
      :rule="site"
      class="float-left"
      :key="site.id"
      @deleted="refreshSites"
      v-on:edit-site="editSite(site)"
    />
    <EditRule v-show="selectedSite" :rule="selectedSite" @saved="refreshSites" @close="selectedSite = undefined" ref="siteEditCard" />
  </div>
  <div v-else-if="!loading">No sites -- would you like to <router-link :to="{ name: 'Create Site' }">create one</router-link>?</div>
</template>

<script>
import { SITES_QUERY } from '@/constants/graphql'
import SiteCard from '@/components/sites/SiteCard.vue'
import EditSite from '@/components/sites/EditSite.vue'

export default {
  name: 'sites',
  data () {
    return {
      selectedSite: undefined,
      error: false,
      loading: 0
    }
  },
  methods: {
    editSite (site) {
      this.selectedSite = {...site}
      // wrapping this in setTimeout allows el to render and next tick to occur
      // timeout even works at 0, but using 100ms delay for safety on slow clients
      setTimeout(() => {
        let position = this.$refs.siteEditCard.$el.scrollHeight + 40
        window.scrollTo({ top: position, behavior: 'smooth' })
      }, 100)
    },
    refreshSites () {
      this.selectedSite = undefined
      this.$apollo.queries.sites.refetch()
    }
  },
  components: {
    SiteCard,
    EditSite
  },
  mounted () {
    this.$apollo.queries.sites.refetch()
  },
  apollo: {
    sites: {
      query: SITES_QUERY,
      error () {
        this.error = true
      }
    }
  }
}
</script>

<style scoped>
</style>
